module.exports = __webpack_public_path__ + "static/media/ae.f8c4953c.svg";